import { Injectable, OnDestroy } from "@angular/core";
import { PinPopupService } from "@mydocma/tile-viewer";
import { UntilDestroy } from "@ngneat/until-destroy";

@UntilDestroy()
@Injectable()
export class MmPinPopupService implements OnDestroy {

  private pinPopupService: PinPopupService;

  constructor() {}

  ngOnDestroy(): void {}

  attachService(pinPopupService: PinPopupService) {
    this.pinPopupService = pinPopupService;
  }

  updatePopup(id: any) {
    this.pinPopupService?.updateMarkerPopup(id);
  }

  closePopup(id: any) {
    this.pinPopupService?.closePopup(id);
  }

  openPopup(id: any, closeAllPreviousPopups = true) {
    this.pinPopupService?.openPopup(id, closeAllPreviousPopups);
  }

}
